import React from "react";

export type Breadcrumb =
	| string
	| { label?: string; url?: string; icon?: string };

export type BreadcrumbContextType = {
	breadcrumbs: Breadcrumb[];
	setBreadcrumbs: React.Dispatch<React.SetStateAction<Breadcrumb[]>>;
};

const breadcrumbContext = React.createContext<BreadcrumbContextType | null>(
	null
);

export default breadcrumbContext;
